module.exports = __webpack_public_path__ + "media/images/expert__tarjei-boe-8fcc6e7b8ae808366da7d2125e422a7f.png";